module.exports = __webpack_public_path__ + "img/yyzz.d363ed58.png";